import React, { useMemo } from 'react'
import { Box } from '@mui/material'
import { Surface, Symbols } from 'recharts'
import { useTranslation } from 'react-i18next'

import chartColors from 'assets/styles/scss/shared/_chart-colors.module.scss'
import styles from 'components/Shared/Charts/utils/LegendCustomFilter.module.scss'
import DefaultScreenSizeTheme from 'assets/styles/themes/DefaultScreenSizeTheme'
import { isMobileView } from 'lib/GlobalConstants'

/**
 * keys to be in { key: 'abc', key: 'xyz } format
 */

type StackedAreaChartProps = {
  keys: any[]
  payload: any[]
  handleFilterClick: any
  legendFilterProps: any
}

export const LegendCustomFilter = ({
  keys,
  payload,
  handleFilterClick,
  legendFilterProps,
}: StackedAreaChartProps) => {
  const { t } = useTranslation()

  //To align legends vertically for mobile view
  const legendContainer = {
    [DefaultScreenSizeTheme.breakpoints.down('sm')]: {
      display: 'flex',
      flexWrap: 'wrap',
      marginTop: '6px',
    },
  }

  return (
    <Box padding={0} margin={0} textAlign={'center'}>
      {useMemo(
        () =>
          payload.map((chart: any, index: number) => {
            const { color } = chart
            const key = keys[index].key
            const active = legendFilterProps[key] === true

            return (
              <Box
                id={key}
                component="span"
                key={index}
                marginLeft={isMobileView ? 0 : 3}
                onClick={handleFilterClick}
                color={active ? chartColors.gray : ''}
                sx={{ ...legendContainer }}
              >
                <Surface
                  id={key}
                  width={15}
                  height={15}
                  style={{ verticalAlign: 'middle' }}
                  cursor={'pointer'}
                >
                  <Symbols
                    cx={7}
                    cy={7}
                    type="circle"
                    size={125}
                    fill={active ? chartColors.gray : color}
                  />
                </Surface>
                <span className={styles.legendLabel}>{t(`charts.${key}`)}</span>
              </Box>
            )
          }),
        payload,
      )}
    </Box>
  )
}
